import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useTheme } from '../../contexts/ThemeContext';
import { fetchAllPaginated } from '../../services/api';
import AgendaDoDia from './AgendaDoDia';

/**
 * Agenda do professor: todas as aulas dele na grade horária, de todas as
 * turmas e escolas, numa linha do tempo do dia.
 *
 * Lê `/class-schedule/?id_teacher=` — o mesmo slot que a coordenação monta
 * na Grade Horária, com início, fim, turma e disciplina. Clicar numa aula
 * abre a chamada daquela turma na data e na aula certas.
 */
export default function AgendaProfessor({ ladoDesktop }) {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { darkMode } = useTheme();
  const [slots, setSlots] = useState(null);
  const [erro, setErro] = useState(null);

  const idTeacher = user?.id_teacher;

  useEffect(() => {
    if (!idTeacher) return;
    let vivo = true;
    fetchAllPaginated('/class-schedule/', {
      id_teacher: idTeacher,
      is_active: true,
      school_year: new Date().getFullYear(),
    })
      .then((r) => vivo && setSlots(r))
      .catch((e) => {
        console.error('Erro ao carregar a agenda:', e);
        if (vivo) setErro('Não foi possível carregar a sua agenda.');
      });
    return () => { vivo = false; };
  }, [idTeacher]);

  // Sem agenda, `ladoDesktop` ainda precisa aparecer no desktop: quem chamou
  // só o mostra fora daqui no celular.
  const semAgenda = ladoDesktop ? <div className="hidden lg:block mb-6">{ladoDesktop}</div> : null;
  if (!idTeacher || erro) return semAgenda;
  if (!slots) {
    return <div className={`h-40 mb-6 rounded-2xl animate-pulse ${darkMode ? 'bg-slate-800/50' : 'bg-slate-100'}`} />;
  }
  if (slots.length === 0) return semAgenda;

  const abrirAula = (aula, data) => {
    const iso = `${data.getFullYear()}-${String(data.getMonth() + 1).padStart(2, '0')}-${String(data.getDate()).padStart(2, '0')}`;
    navigate(`/turmas/${aula.id_class}/diario?tab=frequencia&data=${iso}&aula=${aula.period}`);
  };

  return (
    <AgendaDoDia
      slots={slots}
      darkMode={darkMode}
      onAbrirAula={abrirAula}
      ladoDesktop={ladoDesktop}
      titulo={(
        <h2 className={`text-sm font-semibold -mb-1 ${darkMode ? 'text-slate-100' : 'text-slate-800'}`}>
          Minhas aulas{' '}
          <span className={`font-normal ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>· todas as turmas</span>
        </h2>
      )}
    />
  );
}
